export default function GlobalBackground({ children }) {
    return (
        <div className="min-h-screen bg-red-500"

            style={{
                backgroundImage: "url('/images/bc-image.png')",
            }}
        >
            {/* DARK OVERLAY */}
            <div className="relative min-h-screen bg-black/20">
                {children}
            </div>
        </div>
    );
}
